import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { compose, withProps, withHandlers } from 'recompose';
import { Card } from 'material-ui';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

import { RolesAssignFormBasic } from '@modules/roles-assing/RolesAssignFormBasic';
import { getEmployeeRole, pushEmployeeRole } from '@modules/roles-assing/_rolesAssignActions';
import { rolesAssignLabel, rolesAssignPath } from './RolesAssignGrid';

const enhance = compose<any, any>(
  EntityDetailEnhancer<any, any>({
    getEntity: getEmployeeRole,
    defaultEntity: {}
  }),
  breadcrumbs(() => [{ label: rolesAssignLabel, to: rolesAssignPath }, { label: 'Upravit záznam' }]),
  withProps<{}, any>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  withHandlers({
    onSubmit: ({ closeItem }) => async formData => {
      const result = await pushEmployeeRole(formData);

      if (result) {
        closeItem();
      }
    }
  }),
  reduxForm({})
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <RolesAssignFormBasic />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/roles-assing/RolesAssignForm.tsx